import { useEffect, useState } from "react";
import { ArrowLeftRight } from "lucide-react";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import StatusBadge from "@/components/StatusBadge";
import CoinIcon from "@/components/CoinIcon";
import api from "@/lib/api";
import { formatTRY, formatDate, truncate } from "@/lib/format";

export default function Transactions() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/transactions").then(({ data }) => setItems(data.transactions)).catch(() => setItems([])); }, []);

  return (
    <div>
      <PageHeader title="İşlemler" desc="Onaylanan tüm işlemleriniz." />
      {items === null ? <Spinner /> : items.length === 0 ? (
        <EmptyState icon={ArrowLeftRight} title="Henüz işlem yok" desc="Onaylanan ödemeler burada listelenir." />
      ) : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-border bg-muted/40">
                <tr className="text-left text-xs text-muted-foreground">
                  {["İşlem ID", "Tutar (₺)", "Kripto", "Coin/Ağ", "Komisyon", "Net", "Hash", "Tarih"].map((h) => <th key={h} className="px-4 py-3 font-medium whitespace-nowrap">{h}</th>)}
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-testid="transactions-table">
                {items.map((t) => (
                  <tr key={t.id} className="hover:bg-muted/30">
                    <td className="px-4 py-3 font-mono text-xs">{truncate(t.id, 8)}</td>
                    <td className="px-4 py-3 font-semibold">{formatTRY(t.amount_try)}</td>
                    <td className="px-4 py-3">{Number(t.crypto_amount).toFixed(6)}</td>
                    <td className="px-4 py-3"><span className="inline-flex items-center gap-1.5"><CoinIcon symbol={t.coin} size={18} /> {t.coin} · {t.network}</span></td>
                    <td className="px-4 py-3 text-amber-500">{Number(t.commission).toFixed(6)}</td>
                    <td className="px-4 py-3 font-medium">{Number(t.net_amount).toFixed(6)}</td>
                    <td className="px-4 py-3 font-mono text-xs">{truncate(t.tx_hash || "-", 6)}</td>
                    <td className="px-4 py-3 text-muted-foreground text-xs whitespace-nowrap">{formatDate(t.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
